import { render, staticRenderFns } from "./TabInformation.vue?vue&type=template&id=3ffaa142&"
import script from "./TabInformation.vue?vue&type=script&lang=js&"
export * from "./TabInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports